import { storedImageUrl } from "@/lib/upload";

interface Props {
  name: string;
  src?: string | null;
  className?: string;
  size?: number;
}

export function PlayerAvatar({ name, src, className = "", size = 32 }: Props) {
  const url = storedImageUrl(src ?? null);
  const style = { width: size, height: size };
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        style={style}
        className={`rounded-full object-cover border border-secondary/30 shrink-0 ${className}`}
      />
    );
  }
  return (
    <div
      style={style}
      className={`rounded-full bg-secondary/20 text-secondary flex items-center justify-center font-bold shrink-0 ${className}`}
    >
      {initial}
    </div>
  );
}
